import {
  Box,
  Button,
  Typography,
} from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { BooleanParam, useQueryParam } from 'use-query-params';
import useDecisionTreePreviewContext from '../../App/Contexts/DecisionTree/DecisionTreePreviewContext';
import { useUserInfoData } from '../../App/Hooks/useUserInfo';
import {
  useConsentToLinksMutation,
  useGetAccessConcentLinksQuery,
} from '../../generated/core-api/graphql-react-query';
import EmptyLayout from '../EmptyLayout';
import LinksForm from './Components/LinksForm';
import StyledBox from './styles';

export default function AccessConsentPage(props: { children: React.ReactNode }) {
  const { children } = props;
  const organisationData = useGetAccessConcentLinksQuery();
  const user = useUserInfoData();
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');
  const organisation = organisationData.data?.org;
  const { t: tCommon } = useTranslation('common');
  const [isPreview] = useQueryParam('preview', BooleanParam);
  const isDecisionTreePreview = useDecisionTreePreviewContext();

  const consentToLink = useConsentToLinksMutation<Error>({
    onSuccess() {
      queryClient.invalidateQueries(['getLiveUserInfo']);
    },
  });

  const links = organisation?.additionalConsentUrlsEN || organisation?.additionalConsentUrlsFR;

  if (!user.appSettings?.consentedLinks && links?.length > 0 && !isPreview && !isDecisionTreePreview) {
    return (
      <EmptyLayout>
        <StyledBox>
          <Box>
            <Typography variant="h4">{t('access.title')}</Typography>
            <Box className="content">
              <Typography variant="body2">
                <Trans
                  i18nKey="access.description"
                  t={t}
                  components={{ 1: <strong /> }}
                />
              </Typography>
              <LinksForm organisation={organisation} />
              <Typography variant="body2">{t('access.reminder')}</Typography>
            </Box>
            <Typography variant="body2">{t('access.help')}</Typography>
            <Button
              onClick={() => consentToLink.mutate({})}
              variant="contained"
              color="primary"
            >
              {tCommon('continue')}
            </Button>
          </Box>
        </StyledBox>
      </EmptyLayout>
    );
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return (<>{children}</>);
}
